<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0 storepnr">
      <b-card-header id="storepnr-card-header" class="pl-2 pr-3 small">
        <!-- {{ $moment().diff($moment(storepnr.timestamp,'DD/MM/YYYY HH:mm:SS'), 'minutes') }} -->
        Store PNR ( TP )
        <div class="card-header-actions">
          {{ storepnr.timestamp }}
          <span
            id="storepnr_ago"
            :class="'ml-2 status-dot ' + lastrunstatus"
            pulse="true"
          ></span>
        </div>
      </b-card-header>
      <b-tooltip target="storepnr-card-header" triggers="hover"
        >Store PNR is the TP plug in that writes data to the database</b-tooltip
      >
      <b-tooltip target="storepnr_ago" triggers="hover">{{
        $moment(storepnr.timestamp, "DD/MM/YYYY HH:mm:SS") | formatTimeago
      }}</b-tooltip>
      <b-card-body class="px-0 pt-0">
        <b-table
          v-if="storepnr.showtable"
          ref="storetable"
          id="storetable"
          sticky-header="205px"
          selectable
          select-mode="single"
          striped
          fixed
          small
          bordered
          :items="items"
          :fields="fields"
          @row-selected="onRowSelected"
          class="gridtable my-0"
        ></b-table>
        <b-row class="excelsheetbuttons">
          <b-col>
            <b-button-group>
              <b-button
                size="sm"
                squared
                :pressed="storepnr.active == 'waiting'"
                @click="storepnr.active = 'waiting'"
                variant="outline-warning"
                class="status"
                title="Waiting"
                id="waiting"
              >
                <i class="fa fa-clock-o"></i>
                <!-- <span class="d-none d-lg-inline pl-1"><nobr/>{{storepnr.waiting.length}}<nobr/></span> -->
                <span class="pl-1">
                  <nobr />
                  {{ storepnr.waiting.length }}
                  <nobr />
                </span>
              </b-button>
              <b-tooltip target="waiting" triggers="hover"
                >Displaying the number of XML PNR's waiting to be
                processed</b-tooltip
              >
              <b-button
                size="sm"
                squared
                :pressed="storepnr.active == 'processed'"
                @click="storepnr.active = 'processed'"
                variant="outline-success"
                class="status"
                title="Processed"
                id="processed"
              >
                <i class="fa fa-check-square-o"></i>
                <!--  <span class="d-none d-lg-inline pl-1"><nobr/>{{storepnr.processed.length}}<nobr/></span> -->
                <span class="pl-1">
                  <nobr />
                  {{ storepnr.processed.length }}
                  <nobr />
                </span>
              </b-button>
              <b-tooltip target="processed" triggers="hover"
                >Displaying the number of XML PNR's that have been sucessfully
                processed</b-tooltip
              >
              <b-button
                squared
                size="sm"
                :pressed="storepnr.active == 'failed'"
                @click="storepnr.active = 'failed'"
                variant="outline-danger"
                class="mr-1 status"
                title="Failed"
                id="failed"
              >
                <i class="fa fa-window-close-o"></i>
                <!--   <span class="d-none d-lg-inline pl-1"><nobr/>{{storepnr.failed.length}}<nobr/></span> -->
                <span class="pl-1">
                  <nobr />
                  {{ storepnr.failed.length }}
                  <nobr />
                </span>
              </b-button>
              <b-tooltip target="failed" triggers="hover"
                >Displaying the number of XML PNR's that have failed to be
                processed</b-tooltip
              >
              <b-button
                squared
                size="sm"
                variant="outline-secondary"
                id="storepnr_log"
                :pressed="storepnr.active == 'log'"
                @click="storepnr.active = 'log'"
              >
                <i class="fa fa-list-ol"></i>
              </b-button>
              <b-tooltip target="storepnr_log" triggers="hover"
                >Show log</b-tooltip
              >
              <!-- <b-button
                squared
                size="sm"
                :pressed="storepnr.active=='ignored'"
                @click="storepnr.active='ignored'"
                variant="outline-secondary"
                class="mr-1 status"
                title="Ignored"
                id="ignored"
              >
                <i class="fa fa-warning"></i>
                <span class="pl-1">
                  <nobr />
                  {{storepnr.ignored.length}}
                  <nobr />
                </span>
              </b-button>
              <b-tooltip
                target="ignored"
                triggers="hover"
              >Displaying the number of XML PNR's that have been ignored</b-tooltip>-->
            </b-button-group>
          </b-col>

          <b-col cols="2" class="text-right">
            <b-button-group size="sm" class="float-right ml-1">
              <b-link
                id="storepnr-xml"
                class="mt-1 mr-2"
                @click="outputStream()"
                title="Show xml"
              >
                <i class="fa fa-file-code-o" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="storepnr-xml" triggers="hover"
                >Show XML</b-tooltip
              >

              <b-link id="storepnr-start" disabled size="sm" class="mt-1 mr-2">
                <i class="fa fa-play"></i>
              </b-link>
              <b-tooltip target="storepnr-start" triggers="hover"
                >Service is started</b-tooltip
              >
              <b-link id="storepnr-end" disabled size="sm" class="mt-1 mr-2">
                <i class="fa fa-stop"></i>
              </b-link>
              <b-tooltip target="storepnr-end" triggers="hover"
                >Stop service</b-tooltip
              >
              <b-link
                id="storepnr-excel"
                class="mt-1 excel"
                @click="$helpers.outputExcel({ items, fields: options.fields })"
                title="Send to excel"
              >
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="storepnr-excel" triggers="hover"
                >Grid to excel</b-tooltip
              >
              <!--    <b-link
                class="mt-1"
                size="sm"
                variant="outline-primary"
                title="Expand/collapse"
                @click="storepnr.showtable=!storepnr.showtable"
              >
                <i v-if="storepnr.showtable" class="fa fa-arrow-up"></i>
                <i v-if="!storepnr.showtable" class="fa fa-arrow-down"></i>
              </b-link>-->
            </b-button-group>
          </b-col>
        </b-row>
        <b-row v-if="storepnr.showstream" class="mt-2">
          <b-col v-if="storepnr.file_stream">
            <ssh-pre language="xml" :label="storepnr.selected[0].name">{{
              storepnr.file_stream
            }}</ssh-pre>
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
              <span class="small text-primary ml-2">Updating ...</span>
            </div>
            <span v-if="!busy" class="small text-primary"
              >Showing {{ items.length }} {{ storepnr.active }} file(s)</span
            >
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!--  {{items}} -->
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import moment from "moment";

import SshPre from "simple-syntax-highlighter";
import "simple-syntax-highlighter/dist/sshpre.css";

export default {
  name: "StorePNRStatus",
  components: {
    SshPre,
  },
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      timeout: false,
      disabled: true,
      name: "StorePNRStatus",
      storepnr: {
        lastrunstatus: "danger",
        timestamp: "Unknown",
        status: "negative",
        showtable: true,
        showstream: false,
        selected: null,
        file_stream: null,
        active: "waiting",
        format: "grid",
        waiting: [],
        processed: [],
        failed: [],
        log: [],
        fields: [
          {
            key: "updated_at",
            label: "Date and Time",
            sortable: true,
            sortDirection: "desc",
            class: "w-30pct",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .format("DD/MM/YYYY HH:mm:SS");
              }
              return result;
            },
          },
          {
            key: "name",
            label: "Name",
            sortable: true,
            sortDirection: "desc",
            class: "w-50pct",
          },
          {
            key: "size",
            label: "Size",
            sortable: true,
            sortDirection: "desc",
            formatter: (value, key, item) => {
              return this.$options.filters.formatSize(value);
            },
          },
        ],
        fields_log: [
          {
            key: "date",
            label: "Date and Time",
            sortable: true,
            sortDirection: "desc",
            class: "w-30pct",
          },
          {
            key: "message",
            label: "Message",
            sortable: true,
            sortDirection: "desc",
            class: "w-70pct",
          },
        ],
      },
    };
  },
  async mounted() {
    this.$helpers.resizableColumns();
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    items() {
      switch (this.storepnr.active) {
        case "waiting":
          return this.storepnr.waiting;
        case "processed":
          return this.storepnr.processed;
        // case "ignored":
        //   return this.storepnr.ignored;
        case "failed":
          return this.storepnr.failed;
        case "log":
          return this.storepnr.log;
      }
    },
    fields() {
      switch (this.storepnr.active) {
        case "waiting":
          return this.storepnr.fields;
        case "processed":
          return this.storepnr.fields;
        case "failed":
          return this.storepnr.fields;
        case "log":
          return this.storepnr.fields_log;
      }
    },
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Table";
      }
    },
    lastrunstatus() {
      let result = "danger";
      if (this.storepnr.timestamp != "Unknown") {
        let minutes = this.$moment().diff(
          this.$moment(this.storepnr.timestamp, "DD/MM/YYYY HH:mm:SS"),
          "minutes"
        );
        if (minutes <= 5) {
          result = "success";
        } else if (minutes > 5 && minutes < 60) {
          result = "warning";
        } else {
          result = "danger";
        }
      }
      return result;
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: StorePNRStatus");

      this.busy = true;
      let variables = {};
      variables.id = "storepnr_log";
      try {
        const response = await this.$apollo.query({
          query: gql`
            query file_date($id: String) {
              file_date(id: $id)
            }
          `,
          variables,
        });
        if (response.data.file_date) {
          this.storepnr.timestamp = this.$moment
            .unix(response.data.file_date / 1000)
            .format("DD/MM/YYYY HH:mm:SS");
        }
      } catch (error) {
        console.log(error);
      }
      try {
        const response = await this.$apollo.query({
          query: gql`
            query file_read($id: String) {
              file_read(id: $id)
            }
          `,
          variables,
        });

        this.storepnr.log = [];

        let contents = JSON.parse(response.data.file_read);
        if (contents) {
          contents = contents.split("}\n{").join("},{").split("},");
          for (var j = contents.length - 1; j >= 0; j--) {
            try {
              let obj = JSON.parse(contents[j] + "}");
              obj.date = this.$moment(obj.date, "YYYY-MM-DD HH:mm:SS").format(
                "DD/MM/YYYY HH:mm:SS"
              );
              this.storepnr.log.push(obj);
              // DONT LIMIT THIS
              // if (this.storepnr.log.length > 999) {
              //   break;
              // }
            } catch (error) {
              console.log(j, contents[j], error);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }

      variables.id = "storepnr_waiting";
      variables.deep = false;
      variables.orderby = "updated_at|DESC";
      try {
        const response = await this.$apollo.query({
          query: gql`
            query folder_files($id: String, $deep: Boolean, $orderby: String) {
              folder_files(id: $id, deep: $deep, orderby: $orderby) {
                updated_at
                name: filename
                size
                path
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.storepnr.waiting = response.data.folder_files;
      } catch (error) {
        console.log(error);
      }
      variables.id = "storepnr_processed";
      variables.deep = false;
      variables.orderby = "updated_at|DESC";
      try {
        const response = await this.$apollo.query({
          query: gql`
            query folder_files($id: String, $deep: Boolean, $orderby: String) {
              folder_files(id: $id, deep: $deep, orderby: $orderby) {
                updated_at
                name: filename
                size
                path
              }
            }
          `,
          variables,
        });
        this.storepnr.processed = response.data.folder_files;
      } catch (error) {
        console.log(error);
      }
      variables.id = "storepnr_failed";
      variables.deep = false;
      variables.orderby = "updated_at|DESC";
      try {
        const response = await this.$apollo.query({
          query: gql`
            query folder_files($id: String, $deep: Boolean, $orderby: String) {
              folder_files(id: $id, deep: $deep, orderby: $orderby) {
                updated_at
                name: filename
                size
                path
              }
            }
          `,
          variables,
        });
        this.storepnr.failed = response.data.folder_files;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
      await this.$emit("refreshed");
    },
    async loadFile(a) {
      this.busy = true;
      this.storepnr.file_stream = null;
      let variables = {
        path: a,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query file_read($path: String) {
              file_read(path: $path)
            }
          `,
          variables,
        });
        this.storepnr.file_stream = JSON.parse(response.data.file_read);
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async outputStream() {
      this.storepnr.showstream = !this.storepnr.showstream;
      await this.loadFile(this.storepnr.selected[0].path);
    },

    async action(e) {
      console.log("action", e.key);
      switch (e.key) {
        case "refresh":
          await this.loadChart();
          break;
      }
    },
    onRowSelected(e) {
      this.storepnr.selected = e;
      this.loadFile(e[0].path);
    },
  },
};
</script>

<style>
.ssh-pre__content {
  color: #3cb450;
}
.ssh-pre .quote {
  color: #0bc;
}
.ssh-pre[data-type="xml"] .tag-name {
  color: #c6d;
}
</style>